/**
 * English (GBP base) cross-currency transactions for the multi-currency use
 * case. Foreign-currency rows carry their own symbol so the real DataTable
 * renders a £/$/€/¥ mix; the transfer pair shows both sides via `paired*`.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_CROSS_CURRENCY_TRANSACTIONS_EN = [
	{
		id: 'xcur-1',
		isTransferPair: true,
		date: '2026-08-05',
		type: 'Transfer',
		amount: 500,
		description: 'To US Brokerage',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Savings',
		pairedType: 'Transfer',
		pairedAmount: 660,
		pairedCurrencySymbol: '$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: 'US Brokerage',
		pairedAccountId: 'acc-us',
		pairedDate: '2026-08-05',
	},
	{
		id: 'xcur-2',
		date: '2026-08-04',
		type: 'Deposit',
		amount: 2400,
		description: 'Salary',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Income',
	},
	{
		id: 'xcur-3',
		date: '2026-08-02',
		type: 'Purchase',
		amount: 129,
		description: 'Software subscription',
		accountId: 'acc-us',
		accountName: 'US Brokerage',
		currency: 'USD',
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		tagNames: 'Business',
	},
	{
		id: 'xcur-4',
		date: '2026-07-29',
		type: 'Purchase',
		amount: 42.5,
		description: 'Paris hotel',
		accountId: 'acc-eur',
		accountName: 'Euro Card',
		currency: 'EUR',
		currencySymbol: '\u20AC',
		currencyDecimalPlaces: 2,
		tagNames: 'Travel',
	},
	{
		id: 'xcur-5',
		date: '2026-07-25',
		type: 'Purchase',
		amount: 1280,
		description: 'Convenience store',
		accountId: 'acc-jpy',
		accountName: 'Tokyo Card',
		currency: 'JPY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 0,
		tagNames: 'Food',
	},
];
